module.exports = __webpack_public_path__ + "static/media/produce2.38b7cae8.png";